import React from 'react';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import './NoData.scss';

export interface INoDataProps {
  /** 标题，不传则使用 no_data.title */
  title?: string;
  /** 第一行文案，不传则使用 no_data.one */
  one?: string;
  /** 第二行文案，不传则使用 no_data.two */
  two?: string;
  /** 第三行文案，不传则使用 no_data.three */
  three?: string;
}

export default function NoData(props: INoDataProps = {}) {
  const { title: titleProp, one: oneProp, two: twoProp, three: threeProp } = props;
  const { dblFormatMessage: noDataFormat } = useDblIntl('no_data');
  const title = titleProp ?? noDataFormat('title');
  const one = oneProp ?? noDataFormat('one');
  const two = twoProp ?? noDataFormat('two');
  const three = threeProp ?? noDataFormat('three');

  return (
    <div className="no-datalist">
      <img className="no-datalist-img" src={require('@/pages/datalab/assets/img/no-data.png')} />
      <div className="no-datalist-title">{title}</div>
      <div className="no-datalist-text">
        {one}
        <br />
        {two}
        <br />
        {three}
      </div>
    </div>
  );
}
